export default {
    "allotment": {
        "model": {
            "license": "Alvará",
            "license_type_id": "Tipo",
            "license_status_id": "Estado",
            "license_status_at": "Alteração Estado",
            "license_owner_id": "Titular",
            "process": "Processo",
            "process_approved_at": "Processo Aprovado",
            "issue_request": "Ped. Emissão",
            "issue_request_approved_at": "Ped. Emissão Aprovado",
            "license_issued_at": "Emissão Alvará",
            "license_validity": "Validade Alvará",
            "place_id": "Local",
            "obs": "Observações",
            "notes": "Notas Internas",
            "status_id": "Situação Interna",
            "uses": "Usos",
            "uopgs": "UOPGs",
            "parishes": "Freguesias",

            // LOTEAMENTO AREAS
            "ground_area": "C. Reg. Predial",
            "interv_area": "Intervenção",
            "ext_interv_area": "Intervenção Exterior",
            "remain_area": "Remanescente",
            "total_area": "Loteamento",
            "lots_area": "Lotes",
            "deployment_area": "Implantação",
            "waterproofing_area": "Impermeabilização",
            "easement_area": "Ónus de Servidão",
            "habitation_ac": "Habitação",
            "habitation_cc_ac": "Habitação CC",
            "commerce_ac": "Comércio",
            "services_ac": "Serviços",
            "com_serv_ac": "Comércio e Serviços",
            "industry_ac": "Indústria",
            "equipments_ac": "Equipamentos",
            "tourism_ac": "Turismo",
            "basement_ac": "Caves Hab. Com. Serv.",
            "total_abc_ac": "ABC Total 2012",
            "basement_parking_ac": "Caves (dest. a estac.)",
            "parking_ac": "Estacionamento",
            "storage_ac": "Arrecadações",
            "basement_storage": "Arrecadações Cave",
            "technical_areas": "Áreas Técnicas",
            "basement_technical_areas": "Áreas Técnicas Cave",
            "attached_construction": "Anexo/s",
            "others_ac": "Outros",
            "others_ac_obs": "Outros Descr.",
            "circulation_spaces": "Exterior Coberto",
            "total_abc_ttctrl": "ABC Total",

            "green_space_private_acd": "Espaços Verdes",
            "green_space_type_private_acd_id": "Tipologia E.V.",
            "equipments_private_acd": "Equip. HabPub",
            "equipment_type_private_acd_id": "Tipologia Equip. HabPub",
            "others_private_acd": "Outros",
            "others_private_acd_obs": "Outros Descr.",
            "total_private_acd": "Domínio Privado Total",

            "streets_public_acd": "Vias",
            "parking_public_acd": "Estacionamento",
            "total_sps_public_acd": "Arr+Estac+Pass",

            "green_space_public_acd": "Espaços Verdes",
            "green_space_type_public_acd_id": "Tipologia E.V.",
            "equipments_public_acd": "Equipamentos",
            "equipment_type_public_acd_id": "Tipologia Equipamentos",
            "others_public_acd": "Outros",
            "others_public_acd_obs": "Outros Descr.",
            "total_public_acd": "Domínio Público Total",
            "total_acd": "Área de Cedência Total",

            // LOTEAMENTO ESTATISTICA
            "index_deployment": "Índ. Implantação (IA)",
            "index_construction": "Índ. Construção (IC)",
            "index_land_occupation": "Índ. Ocup. Solo (IOS)",
            "index_land_use": "Índ. Util. Solo (IUS)",
            // "index_land_use_2012": "",
            "index_land_waterproofing": "Índ. Impermeab. (Iimp)",
            "housing_density": "Dens. Habitacional (Db)",

            "n_lots": "Nº Lotes",
            "n_single_family_house": "Nº Moradia Unifamiliar",
            "n_two_family_house": "Nº Moradia Bifamiliar",
            "n_collective_house": "Nº Habitação Colectiva/Misto",
            "n_commerce": "Nº Comércio",
            "n_services": "Nº Serviços",
            "n_com_serv": "Nº Comércio/Serviços",
            "n_industry": "Nº Indústria",
            "n_storage": "Nº Armazéns",
            "n_equipments": "Nº Equipamentos",
            "n_other_uses": "Nº Outros Usos",
            "other_uses_obs": "Outros Usos Descr.",
            "n_buildings": "Nº Edifícios",
            "n_floors": "Total de Pisos",
            "lot_name": "Lote",
            "n_floors_above_cs": "Acima Cota Soleira",
            "lot_name_above_cs": "Lt. Acima Cota Soleira",
            "n_floors_below_cs": "Abaixo Cota Soleira",
            "lot_name_below_cs": "Lt. Abaixo Cota Soleira",
            "n_lots_t0": "T0",
            "n_lots_t1": "T1",
            "n_lots_t2": "T2",
            "n_lots_t3": "T3",
            "n_lots_t4": "T4",
            "n_lots_t5ag": "T5 ou Maior",
            "n_lots_undiff": "T Indefinido",
            "n_lots_cc": "Custos Controlados",
            "n_total_lots": "Total de Fogos",

            "n_parking_covered_public": "Coberto",
            "n_parking_uncovered_public": "Descoberto",
            "n_parking_public": "Total Público",
            "n_parking_covered_private": "Coberto",
            "n_parking_uncovered_private": "Descoberto",
            "n_parking_private": "Total Privado",
            "n_total_parking": "Total de Lugares",

            // LOTEAMENTO AMENDMENTS
            "amendments": {
                "amendments": "Aditamentos",
                "entity": "Aditamento",
                "id": "Id",
                "num": "Número",
                "amendment_at": "Data",
                "requirement": "Requerimento",
                "description": "Descrição"
            },

            // LOTEAMENTO GUARANTEE
            "guarantees": {
                "guarantees": "Caução",
                "entity": "Caução",
                "id": "Id",
                "license_guarantee_type_id": "Tipo",
                "license_guarantee_state_id": "Estado",
                "license_guarantee_owner_id": "Titular",
                "license_guarantee_at": "Data de Emissão",
                "license_guarantee": "Nome / Nº",
                "surety": "Valor da Caução",
                "currency_id": "Moeda",
                "overall_amount": "Montante Global",
                "obs": "Observações",

                "deposits": {
                    "deposits": "Amortizações",
                    "entity": "Amortização",
                    "id": "Id",
                    "deposit_at": "Data",
                    "obs": "Observações",
                    "amount": "Valor"
                }
            },

            // LOTEAMENTO DOCUMENTS
            "files": {
                "files": "Documentos",
                "entity": "Documento",
                "id": "Id",
                "license_file_type_id": "Tipo",
                "path": "Ficheiro",
                "file_at": "Data",
                "description": "Observações",
                "allotment_amendment_id": "Aditamento",
                "active": "Em vigor",
            },

            // LOTEAMENTO LOTS
            "lots": {
                "lots": "Lotes",
                "entity": "Lote",
                "id": "Id",
                "name": "Nº",
                "total_area": "Lote",
                "deployment_area": "Implant.",
                "waterproofing_area": "Imperm.",
                "habitation_ac": "Habit.",
                "habitation_cc_ac": "Habit. CC",
                "commerce_ac": "Com.",
                "services_ac": "Serv.",
                "com_serv_ac": "Com. Serv.",
                "industry_ac": "Ind.",
                "equipments_ac": "Equip.",
                "basement_ac": "Caves",
                "parking_ac": "Estac.",
                "storage_ac": "Arrec.",
                "others_ac": "Outros",
                "total_abc_ac": "ABC Total",
                "private_patio_area": "Logr. Priv.",

            }
        },
        "audit": {
            "models": {
                "allotment": "Loteamento",
                "allotmentamendment": "@:allotment.audit.allotmentamendment.entity (ID: {model_id})",
                "allotmentlot": "@:allotment.audit.allotmentlot.entity (ID: {model_id})",
                "allotmentlicenseguarentee": "@:allotment.audit.allotmentlicenseguarentee.entity",
                "allotmentlicenseguarenteedeposit": "@:allotment.audit.allotmentlicenseguarenteedeposit.entity (ID: {model_id})",
                "allotmentfile": "@:allotment.audit.allotmentfile.entity (ID: {model_id})",
            },

            "allotment": {
                "license": "@:allotment.model.license",
                "license_type_id": "@:allotment.model.license_type_id",
                "license_status_id": "@:allotment.model.license_status_id",
                "license_status_at": "@:allotment.model.license_status_at",
                "license_owner_id": "@:allotment.model.license_owner_id",
                "process": "@:allotment.model.process",
                "process_approved_at": "@:allotment.model.process_approved_at",
                "issue_request": "@:allotment.model.issue_request",
                "issue_request_approved_at": "@:allotment.model.issue_request_approved_at",
                "license_issued_at": "@:allotment.model.license_issued_at",
                "license_validity": "@:allotment.model.license_validity",
                "place_id": "@:allotment.model.place_id",
                "obs": "@:allotment.model.obs",
                "notes": "@:allotment.model.notes",
                "status_id": "@:allotment.model.status_id",
                "uses": "@:allotment.model.uses",
                "uopgs": "@:allotment.model.uopgs",
                "parishes": "@:allotment.model.parishes",

                // LOTEAMENTO AREAS
                "ground_area": "Área @:allotment.model.ground_area",
                "interv_area": "Área @:allotment.model.interv_area",
                "ext_interv_area": "Área @:allotment.model.ext_interv_area",
                "remain_area": "Área @:allotment.model.remain_area",
                "total_area": "Área @:allotment.model.total_area",
                "lots_area": "Área @:allotment.model.lots_area",
                "deployment_area": "Área @:allotment.model.deployment_area",
                "waterproofing_area": "Área @:allotment.model.waterproofing_area",
                "easement_area": "Área @:allotment.model.easement_area",
                "habitation_ac": "Área @:allotment.model.habitation_ac",
                "habitation_cc_ac": "Área @:allotment.model.habitation_cc_ac",
                "commerce_ac": "Área @:allotment.model.commerce_ac",
                "services_ac": "Área @:allotment.model.services_ac",
                "com_serv_ac": "Área @:allotment.model.com_serv_ac",
                "industry_ac": "Área @:allotment.model.industry_ac",
                "equipments_ac": "Área @:allotment.model.equipments_ac",
                "tourism_ac": "Área @:allotment.model.tourism_ac",
                "basement_ac": "Área @:allotment.model.basement_ac",
                "total_abc_ac": "Área @:allotment.model.total_abc_ac",
                "basement_parking_ac": "Área @:allotment.model.basement_parking_ac",
                "parking_ac": "Área @:allotment.model.parking_ac",
                "storage_ac": "Área @:allotment.model.storage_ac",
                "basement_storage": "Área @:allotment.model.basement_storage",
                "technical_areas": "Área @:allotment.model.technical_areas",
                "basement_technical_areas": "Área @:allotment.model.basement_technical_areas",
                "attached_construction": "Área @:allotment.model.attached_construction",
                "others_ac": "Área @:allotment.model.others_ac",
                "others_ac_obs": "Área @:allotment.model.others_ac_obs",
                "circulation_spaces": "Área @:allotment.model.circulation_spaces",
                "total_abc_ttctrl": "Área @:allotment.model.total_abc_ttctrl",

                "green_space_private_acd": "Domínio Privado - Área @:allotment.model.green_space_private_acd",
                "green_space_type_private_acd_id": "Domínio Privado - @:allotment.model.green_space_type_private_acd_id",
                "equipments_private_acd": "Domínio Privado - Área @:allotment.model.equipments_private_acd",
                "equipment_type_private_acd_id": "Domínio Privado - @:allotment.model.equipment_type_private_acd_id",
                "others_private_acd": "Domínio Privado - Área @:allotment.model.others_private_acd",
                "others_private_acd_obs": "Domínio Privado - @:allotment.model.others_private_acd_obs",
                "total_private_acd": "Domínio Privado - Área Total",

                "streets_public_acd": "Domínio Público - Área @:allotment.model.streets_public_acd",
                "parking_public_acd": "Domínio Público - Área @:allotment.model.parking_public_acd",
                "total_sps_public_acd": "Domínio Público - Área @:allotment.model.total_sps_public_acd",

                "green_space_public_acd": "Domínio Público - Área @:allotment.model.green_space_public_acd",
                "green_space_type_public_acd_id": "Domínio Público - @:allotment.model.green_space_type_public_acd_id",
                "equipments_public_acd": "Domínio Público - Área @:allotment.model.equipments_public_acd",
                "equipment_type_public_acd_id": "Domínio Público - @:allotment.model.equipment_type_public_acd_id",
                "others_public_acd": "Domínio Público - Área @:allotment.model.others_public_acd",
                "others_public_acd_obs": "Domínio Público - @:allotment.model.others_public_acd_obs",
                "total_public_acd": "Domínio Público - Área Total",
                "total_acd": "@:allotment.model.total_acd",

                // LOTEAMENTO ESTATISTICA
                "index_deployment": "Indicadores Urbanísticos - @:allotment.model.index_deployment",
                "index_construction": "Indicadores Urbanísticos - @:allotment.model.index_construction",
                "index_land_occupation": "Indicadores Urbanísticos - @:allotment.model.index_land_occupation",
                "index_land_use": "Indicadores Urbanísticos - @:allotment.model.index_land_use",
                "index_land_waterproofing": "Indicadores Urbanísticos - @:allotment.model.index_land_waterproofing",
                "housing_density": "Indicadores Urbanísticos - @:allotment.model.housing_density",

                "n_lots": "@:allotment.model.n_lots",
                "n_single_family_house": "@:allotment.model.n_single_family_house",
                "n_two_family_house": "@:allotment.model.n_two_family_house",
                "n_collective_house": "@:allotment.model.n_collective_house",
                "n_commerce": "@:allotment.model.n_commerce",
                "n_services": "@:allotment.model.n_services",
                "n_com_serv": "@:allotment.model.n_com_serv",
                "n_industry": "@:allotment.model.n_industry",
                "n_storage": "@:allotment.model.n_storage",
                "n_equipments": "@:allotment.model.n_equipments",
                "n_other_uses": "@:allotment.model.n_other_uses",
                "other_uses_obs": "Nº Outros Usos Descr.",
                "n_buildings": "@:allotment.model.n_buildings",
                "n_floors": "Nº Pisos (edifício c/ maior nº pisos) - @:allotment.model.n_floors",
                "lot_name": "Nº Pisos (edifício c/ maior nº pisos) - @:allotment.model.lot_name",
                "n_floors_above_cs": "Nº Pisos (edifício c/ maior nº pisos) - @:allotment.model.n_floors_above_cs",
                "lot_name_above_cs": "Nº Pisos (edifício c/ maior nº pisos) - @:allotment.model.lot_name_above_cs",
                "n_floors_below_cs": "Nº Pisos (edifício c/ maior nº pisos) - @:allotment.model.n_floors_below_cs",
                "lot_name_below_cs": "Nº Pisos (edifício c/ maior nº pisos) - @:allotment.model.lot_name_below_cs",
                "n_lots_t0": "Nº Fogos - @:allotment.model.n_lots_t0",
                "n_lots_t1": "Nº Fogos - @:allotment.model.n_lots_t1",
                "n_lots_t2": "Nº Fogos - @:allotment.model.n_lots_t2",
                "n_lots_t3": "Nº Fogos - @:allotment.model.n_lots_t3",
                "n_lots_t4": "Nº Fogos - @:allotment.model.n_lots_t4",
                "n_lots_t5ag": "Nº Fogos - @:allotment.model.n_lots_t5ag",
                "n_lots_undiff": "Nº Fogos - @:allotment.model.n_lots_undiff",
                "n_lots_cc": "Nº Fogos - @:allotment.model.n_lots_cc",
                "n_total_lots": "@:allotment.model.n_total_lots",

                "n_parking_covered_public": "Lugares Estacionamento Público - @:allotment.model.n_parking_covered_public",
                "n_parking_uncovered_public": "Lugares Estacionamento Público - @:allotment.model.n_parking_uncovered_public",
                "n_parking_public": "Lugares Estacionamento Público - @:allotment.model.n_parking_public",
                "n_parking_covered_private": "Lugares Estacionamento Privado - @:allotment.model.n_parking_covered_private",
                "n_parking_uncovered_private": "Lugares Estacionamento Privado - @:allotment.model.n_parking_uncovered_private",
                "n_parking_private": "Lugares Estacionamento Privado - @:allotment.model.n_parking_private",
                "n_total_parking": "Lugares Estacionamento - @:allotment.model.n_total_parking",

                "status_user_id": "@:allotment.model.status_id por",
                "status_at": "@:allotment.model.status_id em",
                "created_user_id": "Criado por",
                "updated_user_id": "Alterado por",
                "filled_user_id": "Preenchido por",
                "validated_user_id": "Validado por",
            },

            // LOTEAMENTO AMENDMENTS
            "allotmentamendment": {
                "entity": "@:allotment.model.amendments.entity",
                "id": "@:allotment.model.amendments.id",
                "num": "@:allotment.model.amendments.num",
                "amendment_at": "@:allotment.model.amendments.amendment_at",
                "requirement": "@:allotment.model.amendments.requirement",
                "description": "@:allotment.model.amendments.description"
            },

            // LOTEAMENTO GUARANTEE
            "allotmentlicenseguarentee": {
                "entity": "@:allotment.model.guarantees.entity",
                "id": "@:allotment.model.guarantees.id",
                "license_guarantee_type_id": "@:allotment.model.guarantees.license_guarantee_type_id",
                "license_guarantee_state_id": "@:allotment.model.guarantees.license_guarantee_state_id",
                "license_guarantee_owner_id": "@:allotment.model.guarantees.license_guarantee_owner_id",
                "license_guarantee_at": "@:allotment.model.guarantees.license_guarantee_at",
                "license_guarantee": "@:allotment.model.guarantees.license_guarantee",
                "surety": "@:allotment.model.guarantees.surety",
                "currency_id": "@:allotment.model.guarantees.currency_id",
                "overall_amount": "@:allotment.model.guarantees.overall_amount",
                "obs": "@:allotment.model.guarantees.obs",
            },

            "allotmentlicenseguarenteedeposit": {
                "entity": "@:allotment.model.guarantees.deposits.entity",
                "id": "@:allotment.model.guarantees.deposits.id",
                "deposit_at": "@:allotment.model.guarantees.deposits.deposit_at",
                "obs": "@:allotment.model.guarantees.deposits.obs",
                "amount": "@:allotment.model.guarantees.deposits.amount"
            },

            // LOTEAMENTO DOCUMENTS
            "allotmentfile": {
                "entity": "@:allotment.model.files.entity",
                "id": "@:allotment.model.files.id",
                "license_file_type_id": "@:allotment.model.files.license_file_type_id",
                "filename": "@:allotment.model.files.path",
                "path": "@:allotment.model.files.path",
                "file_at": "@:allotment.model.files.file_at",
                "description": "@:allotment.model.files.description",
                "allotment_amendment_id": "@:allotment.model.files.allotment_amendment_id",
                "active": "@:allotment.model.files.active",
            },

            // LOTEAMENTO LOTS
            "allotmentlot": {
                "entity": "@:allotment.model.lots.entity",
                "id": "@:allotment.model.lots.id",
                "name": "Nº",
                "total_area": "Área - Lote",
                "deployment_area": "Área - Implantação",
                "waterproofing_area": "Área - Impermeabilização",

                "habitation_ac": "Área bruta de construção - Habitação",
                "habitation_cc_ac": "Área bruta de construção - Habitação CC",
                "commerce_ac": "Área bruta de construção - Comércio",
                "services_ac": "Área bruta de construção - Serviços",
                "com_serv_ac": "Área bruta de construção - Comércio e Serviços",
                "industry_ac": "Área bruta de construção - Indústria",
                "equipments_ac": "Área bruta de construção - Equipamentos",
                "basement_ac": "Área bruta de construção - Caves",
                "parking_ac": "Área bruta de construção - Estacionamento",
                "storage_ac": "Área bruta de construção - Arrecadação",
                "others_ac": "Área bruta de construção - Outros",
                "total_abc_ac": "Área bruta de construção - ABC Total",
                "private_patio_area": "Áreas - Logradouro Privado",

                "index_land_occupation": "Índice - Ocupação do Solo",
                "index_land_use": "Índice - Utilzação oo Solo",
                "index_land_waterproofing": "Índice - Impermeabilização do Solo",
                "lot_use_type_id": "Tipo Uso",
                "construction_process": "Processo Construção",
                "construction_license": "Licença Construção",
                "license_use": "Licença Utiliação",

                "n_lots": "Nº Fogos",
                "n_lots_cc": "Nº Fogos CC",
                "n_floors_above_cs": "Nº Fogos - Acima Cota Soleira",
                "n_floors_below_cs": "Nº Fogos - Abaixo Cota Soleira",
                "n_floors": "Total de Pisos",
                "n_floors_descr": "Total de Pisos - Descrição",
                "n_parking_covered": "Nº Estacionamentos - Coberto",
                "n_parking_uncovered": "Nº Estacionamentos - Descoberto",
                "cercea": "Cércea (m)",
                "yielded": "Cedência",
                "obs": "Observações",
                "created_user_id": "Criado por",
                "updated_user_id": "Alterado por",
            },
        },
        "msg": {
            "confirm_fill_data": "Deseja preencher os dados do alvará de loteamento nº <strong>{license}</strong>?"
        }
    }
}
